export const createLinkToken = async (api) => {
  const response = await api.post('/api/plaid/create_link_token');
  return response ? response?.data.link_token : null;
};

export const setAccessToken = async (api, publicToken) => {
  const response = await api.post('/api/plaid/set_access_token', {
    public_token: publicToken,
  });
  return response ? response : null;
};
